import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import { reviews } from '@/mocks/comics';

export default function AboutPage() {
  const breadcrumbItems = [
    { label: '首页', to: '/' },
    { label: '关于我们' },
  ];

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于韩国漫画网',
            description: '韩国漫画网是免费韩漫与漫画大全的聚合地，提供海量在线漫画资源',
            url: 'https://www.koreanmanhwa.cn/about',
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.koreanmanhwa.cn/' },
                { '@type': 'ListItem', position: 2, name: '关于我们' },
              ],
            },
            mainEntity: {
              '@type': 'Organization',
              name: '韩国漫画网',
              url: 'https://www.koreanmanhwa.cn/',
              description: '免费韩漫与漫画大全的聚合地',
              contactPoint: {
                '@type': 'ContactPoint',
                email: 'contact@koreanmanhwa.cn',
                contactType: 'customer service',
                availableLanguage: ['Chinese'],
              },
            },
          }),
        }}
      />

      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-6">
        <Breadcrumb items={breadcrumbItems} />

        {/* Page Header */}
        <div className="mt-6 text-center max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-4xl text-foreground-900">关于韩国漫画网</h1>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            韩国漫画网是免费韩漫与漫画大全的聚合地，提供海量在线漫画资源，专注于推荐好看的韩国漫画，是您的一站式娱乐门户。
          </p>
        </div>

        {/* Brand Introduction */}
        <section className="mt-12">
          <h2 className="font-heading text-2xl text-foreground-900 text-center">
            <a href="#brand-intro" id="brand-intro">品牌介绍</a>
          </h2>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            <div className="bg-background-100 rounded-lg p-6 text-center border border-background-200/70">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-book-read-line text-2xl text-primary-500"></i>
              </div>
              <h3 className="mt-4 font-heading text-lg text-foreground-900">海量资源</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                收录超过1000部优质韩国漫画，涵盖恋爱、奇幻、悬疑、动作等多种类型，满足不同读者的口味需求。
              </p>
            </div>
            <div className="bg-background-100 rounded-lg p-6 text-center border border-background-200/70">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-shield-check-line text-2xl text-accent-600"></i>
              </div>
              <h3 className="mt-4 font-heading text-lg text-foreground-900">品质保障</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                所有漫画均提供精校中文翻译，严格把控翻译质量，确保读者获得原汁原味的阅读体验。
              </p>
            </div>
            <div className="bg-background-100 rounded-lg p-6 text-center border border-background-200/70">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-100">
                <i className="ri-refresh-line text-2xl text-secondary-600"></i>
              </div>
              <h3 className="mt-4 font-heading text-lg text-foreground-900">每日更新</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                坚持每日更新最新漫画内容，热门连载作品保持高频更新节奏，让读者追更不停歇。
              </p>
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="mt-16 max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-xl p-8 border border-background-200/70">
            <h2 className="font-heading text-xl text-foreground-900 text-center">
              <a href="#mission">我们的使命</a>
            </h2>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed text-center max-w-2xl mx-auto">
              韩国漫画网致力于打造华语世界最优质的韩漫阅读平台。我们相信，好的漫画应该被更多人看到。通过聚合海量优质韩漫资源，提供流畅便捷的阅读体验，我们希望能够连接每一位热爱韩国漫画的读者，让好的韩国漫画跨越语言和地域的界限，触达更多人的心灵。
            </p>
          </div>
        </section>

        {/* User Reviews */}
        <section className="mt-16">
          <h2 className="font-heading text-2xl text-foreground-900 text-center">
            <a href="#reviews" id="reviews">用户口碑</a>
          </h2>
          <p className="mt-2 text-sm text-foreground-600 text-center">听听读者们怎么说</p>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
            {reviews.map((review, idx) => (
              <div key={idx} className="bg-background-100 rounded-lg p-5 border border-background-200/70">
                <div className="flex items-center gap-3">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{review.name}</p>
                    <div className="flex items-center gap-0.5">
                      {Array.from({ length: 5 }, (_, i) => (
                        <span key={i} className="w-3 h-3 flex items-center justify-center">
                          <i className={`text-xs ${i < review.rating ? 'ri-star-fill text-yellow-400' : 'ri-star-line text-foreground-300'}`}></i>
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{review.content}</p>
                <p className="mt-2 text-xs text-foreground-400">{review.date}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Stats */}
        <section className="mt-16">
          <div className="bg-background-100 rounded-xl p-8 border border-background-200/70">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
              <div>
                <div className="text-3xl font-bold text-primary-500 font-heading">1000+</div>
                <p className="text-sm text-foreground-600 mt-1">漫画资源</p>
              </div>
              <div>
                <div className="text-3xl font-bold text-accent-600 font-heading">500万+</div>
                <p className="text-sm text-foreground-600 mt-1">月活跃读者</p>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary-500 font-heading">10万+</div>
                <p className="text-sm text-foreground-600 mt-1">总章节数</p>
              </div>
              <div>
                <div className="text-3xl font-bold text-accent-600 font-heading">50+</div>
                <p className="text-sm text-foreground-600 mt-1">内容分类</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="mt-16 pb-10">
          <h2 className="font-heading text-2xl text-foreground-900 text-center">
            <a href="#contact" id="contact">联系我们</a>
          </h2>
          <p className="mt-2 text-sm text-foreground-600 text-center">如有任何问题或建议，欢迎随时联系我们</p>
          <div className="mt-6 max-w-lg mx-auto bg-background-100 rounded-xl p-6 border border-background-200/70">
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-mail-line text-lg text-primary-500"></i>
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-900">电子邮箱</p>
                  <p className="text-sm text-foreground-600">contact@koreanmanhwa.cn</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-customer-service-2-line text-lg text-accent-600"></i>
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-900">客服支持</p>
                  <p className="text-sm text-foreground-600">工作日 9:00 - 18:00 在线服务</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-link text-lg text-secondary-600"></i>
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-900">社交媒体</p>
                  <div className="flex gap-2 mt-1">
                    <a href="#weibo" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">微博</a>
                    <span className="text-foreground-300">·</span>
                    <a href="#wechat" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">微信</a>
                    <span className="text-foreground-300">·</span>
                    <a href="#bilibili" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">哔哩哔哩</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}